import React, { useState, useEffect, useMemo } from "react";
import MasterLayout from "../layouts/MasterLayout";
import { 
  RiAddLine, 
  RiWallet3Line, 
  RiLockPasswordLine, 
  RiBankCardLine, 
  RiSearch2Line, 
  RiFileList3Line, 
  RiMoneyDollarCircleLine, 
  RiEditLine, 
  RiNotification3Line, 
  RiCoinsLine, 
  RiRefreshLine, 
  RiDeleteBinLine, 
  RiEyeLine, 
  RiEyeOffLine,
  RiBuilding4Line,
  RiTelegramLine,
  RiVipCrown2Fill,
  RiCoupon3Line,
  RiShieldFlashLine,
  RiInformationLine,
  RiFileCopyLine,
  RiCheckLine,
  RiArrowRightUpLine,
  RiMore2Fill,
  RiCloseCircleLine
} from "react-icons/ri";
import Dropdown from 'react-bootstrap/Dropdown';
import Modal from 'react-bootstrap/Modal';
import Paginate from "../components/paginate/Paginate";
import ModalCreateBankAccount from "../components/bank/ModalCreateBankAccount";
import ModalHistory from "../components/bank/ModalHistory";
import ModalDepositApp from "../components/bank/ModalDepositApp";
import ModalUpdateAcount from "../components/bank/ModalUpdateAcount";
import ModalPushNoti from "../components/bank/ModalPushNoti";
import ModalEditBalance from "../components/bank/ModalEditBalance";
import ModalRenewAccount from "../components/bank/ModalRenewAccount";
import ModalChangePassword from '../components/bank/ModalChangePassword';
import ModalComboPromo from "../components/bank/ModalComboPromo";
import UserBankAcountModel from "../models/UserBankAcountModel";
import BankModel from "../models/BankModel";
import HomeModel from "../models/HomeModel";
import CodeMoneyModel from "../models/CodeMoneyModel";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import './bank-modern.css';

const CustomToggle = React.forwardRef(({ children, onClick }, ref) => (
  <button
    type="button"
    ref={ref}
    className="btn-action-plus"
    onClick={(e) => {
      e.preventDefault();
      e.stopPropagation();
      onClick(e);
    }}
  >
    {children}
  </button>
));

function BankPage() {
  const navigate = useNavigate();
  const [showCreateBankModal, setShowCreateBankModal] = useState(false);
  const [showChangePasswordModal, setShowChangePasswordModal] = useState(false);
  const [allBanks, setAllBanks] = useState([]);
  const [loading, setLoading] = useState(false);
  const [userData, setUserData] = useState(null);
  const [visiblePasswords, setVisiblePasswords] = useState({});
  const [copiedId, setCopiedId] = useState(null);
  const [accountTypeFilter, setAccountTypeFilter] = useState('ALL');

  const [perPage, setPerPage] = useState(10);
  const [page, setPage] = useState(1);
  const [filter, setFilter] = useState({ search: '' });
  const [keyword, setKeyword] = useState({ search_text: '' });

  const [selectedBank, setSelectedBank] = useState(null);
  const [openDropdownId, setOpenDropdownId] = useState(null);
  const [showHistory, setShowHistory] = useState(false);
  const [showDeposit, setShowDeposit] = useState(false);
  const [showUpdate, setShowUpdate] = useState(false);
  const [showPush, setShowPush] = useState(false);
  const [showEditBalance, setShowEditBalance] = useState(false);
  const [showRenew, setShowRenew] = useState(false);
  const [showComboPromo, setShowComboPromo] = useState(false);
  const [quickCode, setQuickCode] = useState('');
  const [isSubmittingQuickCode, setIsSubmittingQuickCode] = useState(false);
  const [showCodeModal, setShowCodeModal] = useState(false);

  const handleCopyText = (text, id) => {
    if (!text) return;
    navigator.clipboard.writeText(text);
    setCopiedId(id);
    setTimeout(() => setCopiedId(null), 1600);
  };

  const handleQuickDepositCode = () => {
    const cleanCode = (quickCode || '').trim();
    if (!cleanCode) {
      Swal.fire({
        icon: 'warning',
        title: 'Vui lòng nhập mã Code!'
      });
      return;
    }

    setIsSubmittingQuickCode(true);
    CodeMoneyModel.depositCode({ code: cleanCode })
      .then((res) => {
        setIsSubmittingQuickCode(false);
        if (res.success === true) {
          Swal.fire({
            icon: 'success',
            title: res.type === 'vip' ? 'Kích Hoạt VIP Thành Công!' : 'Nạp Tiền Thành Công!',
            text: res.message,
            showConfirmButton: true,
            confirmButtonText: 'Xác nhận'
          });
          setQuickCode('');
          setShowCodeModal(false);
          reloadPage();
        } else {
          Swal.fire({
            icon: 'error',
            title: 'Không thể áp dụng mã',
            text: res.message || 'Mã code không hợp lệ!'
          });
        }
      })
      .catch((err) => {
        setIsSubmittingQuickCode(false);
        Swal.fire({
          icon: 'error',
          title: 'Lỗi kết nối',
          text: err.response?.data?.message || err.message || 'Không thể nạp mã code lúc này!'
        });
      });
  };

  useEffect(() => {
    HomeModel.getInfoHeader().then((res) => {
      setUserData(res.data);
    }).catch(() => {});
  }, []);

  useEffect(() => {
    setLoading(true);
    UserBankAcountModel.getAllUserBankAcounts({ search: filter.search, page: 1, perPage: 1000 })
      .then((res) => { setAllBanks(res.data || []); setLoading(false); })
      .catch((err) => { console.error("Error:", err); setLoading(false); });
  }, [filter]);

  // Client-side pagination, instant search & segmented tab filter
  const filteredBanks = useMemo(() => {
    let list = allBanks;
    if (accountTypeFilter === 'VIP') {
      list = list.filter(b => Number(b.is_from_combo) === 1);
    } else if (accountTypeFilter === 'NORMAL') {
      list = list.filter(b => !b.is_from_combo || Number(b.is_from_combo) === 0);
    }
    const s = (keyword.search_text || filter.search || '').trim().toLowerCase();
    if (!s) return list;
    return list.filter(b => 
      (b.phone && b.phone.toLowerCase().includes(s)) ||
      (b.bank_username && b.bank_username.toLowerCase().includes(s)) ||
      (b.bank_number && b.bank_number.toLowerCase().includes(s)) ||
      (b.type && b.type.toLowerCase().includes(s))
    );
  }, [allBanks, filter.search, keyword.search_text, accountTypeFilter]);

  const vipCount = useMemo(() => allBanks.filter(b => Number(b.is_from_combo) === 1).length, [allBanks]);
  const normalCount = useMemo(() => allBanks.filter(b => !b.is_from_combo || Number(b.is_from_combo) === 0).length, [allBanks]);

  const totalPages = Math.ceil(filteredBanks.length / perPage);
  const banks = useMemo(() => {
    const start = (page - 1) * perPage;
    return filteredBanks.slice(start, start + perPage);
  }, [filteredBanks, page, perPage]);

  const meta = {
    total: filteredBanks.length,
    per_page: perPage,
    current_page: page,
    last_page: totalPages
  };

  const changePage = (pageNum) => setPage(pageNum);
  const handleSetPage = (number) => setPage(Math.max(1, Math.min(totalPages, page + number)));
  const handleChangePerPage = (e) => { 
    const newPerPage = parseInt(e.target.value);
    setPerPage(newPerPage);
    setPage(1);
  };
  const handleChange = (e) => {
    setKeyword({ ...keyword, [e.target.name]: e.target.value });
    setPage(1);
  };
  const handleSubmit = (e) => {
    e.preventDefault();
    setPage(1);
    setFilter({ search: keyword.search_text });
  };
  const handleClearSearch = () => {
    setKeyword({ search_text: '' });
    setFilter({ search: '' });
    setPage(1);
  };
  const handleTabChange = (tab) => {
    setAccountTypeFilter(tab);
    setPage(1);
  };

  const reloadPage = () => { 
    setLoading(true);
    UserBankAcountModel.getAllUserBankAcounts({ search: '', page: 1, perPage: 1000 })
      .then((res) => { setAllBanks(res.data || []); setLoading(false); })
      .catch(() => setLoading(false));
    HomeModel.getInfoHeader().then((res) => {
      setUserData(res.data);
      window.dispatchEvent(new Event('user-data-updated'));
    }).catch(() => {}); 
  };

  const togglePassword = (bankId) => {
    setVisiblePasswords(prev => ({ ...prev, [bankId]: !prev[bankId] }));
  };

  const openHistory = (bank) => { setOpenDropdownId(null); setSelectedBank(bank); setShowHistory(true); };
  const openDeposit = (bank) => { setOpenDropdownId(null); setSelectedBank(bank); setShowDeposit(true); };
  const openUpdate = (bank) => { setOpenDropdownId(null); setSelectedBank(bank); setShowUpdate(true); };
  const openPush = (bank) => { setOpenDropdownId(null); setSelectedBank(bank); setShowPush(true); };
  const openEditBalance = (bank) => { setOpenDropdownId(null); setSelectedBank(bank); setShowEditBalance(true); };
  const openRenew = (bank) => { setOpenDropdownId(null); setSelectedBank(bank); setShowRenew(true); };

  const handleDelete = (id) => {
    setOpenDropdownId(null);
    Swal.fire({
      title: 'Xác nhận xóa tài khoản?', 
      text: "Bạn có chắc chắn muốn xóa tài khoản ngân hàng này khỏi danh sách?", 
      icon: 'warning',
      showCancelButton: true, 
      confirmButtonText: 'Đồng ý xóa', 
      cancelButtonText: 'Hủy bỏ'
    }).then((result) => {
      if (result.isConfirmed) {
        UserBankAcountModel.delete(id).then(() => {
          Swal.fire({ icon: "success", title: "Đã xóa tài khoản!", timer: 1800, showConfirmButton: false });
          reloadPage();
        }).catch(() => {
          Swal.fire({ icon: "error", title: "Xóa thất bại!", timer: 2000, showConfirmButton: false });
        });
      }
    });
  };

  const formatDate = (dateStr) => {
    if (!dateStr) return '-';
    const d = new Date(dateStr);
    return `${d.getDate().toString().padStart(2,'0')}/${(d.getMonth()+1).toString().padStart(2,'0')}/${d.getFullYear()}`;
  };

  const getUserBalance = () => {
    if (!userData) return 0;
    return userData.account_balance || userData.balance || userData.user_balance || 0;
  };

  const refreshData = () => {
    HomeModel.getInfoHeader().then((res) => setUserData(res.data)).catch(() => {});
    setLoading(true);
    UserBankAcountModel.getAllUserBankAcounts({ search: filter.search, page: 1, perPage: 1000 })
      .then((res) => { setAllBanks(res.data || []); setLoading(false); })
      .catch((err) => { console.error("Error:", err); setLoading(false); });
  };

  const handleMassUpgrade = () => {
    const normalBanks = allBanks.filter(b => b.is_from_combo !== 1);
    let totalDaysRequired = 0;
    const now = new Date();
    
    normalBanks.forEach(b => {
      const exp = b.expired_at || b.accountActiveUser?.expired_date;
      if (exp) {
        const diffTime = new Date(exp) - now;
        const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
        if (diffDays > 0) totalDaysRequired += diffDays;
        else totalDaysRequired += 1;
      }
    });

    if (totalDaysRequired === 0) return Swal.fire('Thông báo', 'Các tài khoản thường đều đã hết hạn!', 'info');

    Swal.fire({
      title: 'Nâng cấp toàn bộ lên VIP',
      html: `Bạn có <b>${normalBanks.length}</b> tài khoản thường.<br/>Cần dùng <b>${totalDaysRequired} ngày VIP</b> để nâng cấp đồng loạt (bảo lưu nguyên thời hạn hiện tại).<br/>Bạn đang có ${userData?.combo_days || 0} ngày VIP.`,
      icon: 'question',
      showCancelButton: true,
      confirmButtonText: 'Đồng ý nâng cấp',
      cancelButtonText: 'Hủy'
    }).then((result) => {
      if (result.isConfirmed) {
        BankModel.massUpgradeVip().then(res => {
          if(res.success) {
            Swal.fire('Thành công', res.message, 'success');
            refreshData();
          } else {
            Swal.fire('Lỗi', res.message, 'error');
          }
        }).catch(err => Swal.fire('Lỗi', err.response?.data?.message || 'Có lỗi xảy ra', 'error'));
      }
    });
  };

  const handleSingleUpgrade = (bank) => {
    setOpenDropdownId(null);
    const now = new Date();
    let diffDays = 1;
    const exp = bank.expired_at || bank.accountActiveUser?.expired_date;
    if (exp) {
        const diffTime = new Date(exp) - now;
        diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
        if (diffDays <= 0) diffDays = 1;
    }
    
    Swal.fire({
      title: 'Nâng cấp tài khoản VIP',
      html: `Tài khoản này còn <b>${diffDays} ngày</b> sử dụng.<br/>Hệ thống sẽ trừ <b>${diffDays} ngày VIP</b> trong ví để nâng cấp tài khoản này lên VIP (Miễn phí sửa STK vĩnh viễn).`,
      icon: 'question',
      showCancelButton: true,
      confirmButtonText: 'Đồng ý nâng cấp',
      cancelButtonText: 'Hủy'
    }).then((result) => {
      if (result.isConfirmed) {
        BankModel.upgradeVip({ bank_id: bank.id }).then(res => {
          if(res.success) {
            Swal.fire('Thành công', res.message, 'success');
            refreshData();
          } else {
            Swal.fire('Lỗi', res.message, 'error');
          }
        }).catch(err => Swal.fire('Lỗi', err.response?.data?.message || 'Có lỗi xảy ra', 'error'));
      }
    });
  };

  const hasMassUpgrade = userData?.combo_days > 0 && allBanks.filter(b => Number(b.is_from_combo) !== 1).length > 0;

  return (
    <MasterLayout>
      {/* Top Section: Overview Bento Grid + Action Bar */}
      <div className="bank-top-section">
        {/* Bento 3-Card Overview Grid */}
        <div className="bank-bento-grid">
          <div className="bank-top-row-cards">
            {/* Card 1: User Balance */}
            <div className="bank-balance-card">
              <div className="balance-icon-wrap">
                <RiBankCardLine size={19} />
              </div>
              <div className="balance-info-wrap">
                <span className="balance-label">Số dư khả dụng</span>
                <span className="balance-amount">{getUserBalance().toLocaleString('vi-VN')} đ</span>
              </div>
              <button
                type="button"
                className="bento-card-link"
                onClick={() => navigate('/payment/deposit')}
                title="Nạp thêm số dư"
              >
                <span>Nạp</span>
                <RiArrowRightUpLine size={13} />
              </button>
            </div>

            {/* Card 2: VIP Account Status */}
            {userData?.combo_days > 0 ? (
              <div 
                className="vip-account-badge-card"
                onClick={() => setShowComboPromo(true)}
                role="button"
                title="Đặc quyền Tài khoản VIP Pro - Bấm để xem chi tiết hoặc mua thêm lượt"
              >
                <div className="vip-badge-crown">
                  <RiVipCrown2Fill size={19} />
                </div>
                <div className="vip-badge-text-group">
                  <div className="vip-badge-status">
                    <span className="vip-badge-tag">VIP PRO</span>
                    <span className="vip-badge-lifetime">VĨNH VIỄN</span>
                  </div>
                  <div className="vip-badge-slots-count">
                    Còn <strong>{userData?.combo_days || 0}</strong> ngày (~{Math.floor((userData?.combo_days || 0) / 30)} lượt)
                  </div>
                </div>
                <span className="bento-card-arrow">
                  <RiArrowRightUpLine size={14} />
                </span>
              </div>
            ) : (
              <div 
                className="bank-combo-badge-card"
                onClick={() => setShowComboPromo(true)}
                role="button"
                title="Xem bảng quyền lợi các gói Combo VIP"
              >
                <div className="combo-badge-icon">
                  <RiVipCrown2Fill size={19} />
                </div>
                <div className="combo-badge-info">
                  <span className="combo-badge-title">Đặc quyền Combo VIP</span>
                  <span className="combo-badge-slots">Nâng cấp miễn phí dịch vụ →</span>
                </div>
              </div>
            )}
          </div>

          {/* Card 3: Quick Code / Giftcode Redeem */}
          <div className="bank-quick-code-card">
            <div 
              className="quick-code-icon-wrap" 
              title="Bấm để xem hướng dẫn & quyền lợi chi tiết về mã Code"
              onClick={() => setShowCodeModal(true)}
            >
              <RiCoupon3Line size={19} />
            </div>
            <div className="quick-code-input-wrap">
              <span className="quick-code-label">Kích hoạt Giftcode / VIP</span>
              <input
                type="text"
                placeholder="Nhập mã code tại đây..."
                value={quickCode}
                onChange={(e) => setQuickCode(e.target.value.toUpperCase().trim())}
                onKeyDown={(e) => {
                  if (e.key === 'Enter') {
                    handleQuickDepositCode();
                  }
                }}
              />
            </div>
            <button 
              type="button" 
              className="btn-quick-code-submit"
              onClick={handleQuickDepositCode}
              disabled={isSubmittingQuickCode}
              title="Kích hoạt mã code để nạp tiền hoặc cộng ngày VIP"
            >
              <RiShieldFlashLine size={13} />
              <span>{isSubmittingQuickCode ? 'Đang nạp...' : 'Kích Hoạt'}</span>
            </button>
            <button
              type="button"
              className="btn-quick-code-info"
              onClick={() => setShowCodeModal(true)}
              title="Xem chi tiết & quyền lợi mã Giftcode"
            >
              <RiInformationLine size={16} />
            </button>
          </div>
        </div>

        {/* Action Toolbar Row */}
        <div className="bank-action-bar">
          <div className="bank-section-heading d-none d-lg-flex">
            <h4 className="bank-page-title">Quản Lý Tài Khoản Ngân Hàng</h4>
            <span className="bank-page-subtitle">Vận hành &amp; cấu hình thông tin tài khoản Bank ảo thời gian thực</span>
          </div>

          <div className={`bank-top-row-actions ${hasMassUpgrade ? 'has-4-btns' : 'has-3-btns'}`}>
            <button className="bank-action-btn btn-create-bank" onClick={() => setShowCreateBankModal(true)}>
              <RiAddLine size={16} />
              <span>Tạo Bank Mới</span>
            </button>

            {hasMassUpgrade && (
              <button className="bank-action-btn btn-upgrade-vip" onClick={handleMassUpgrade}>
                <RiVipCrown2Fill size={15} />
                <span>Nâng Cấp VIP</span>
              </button>
            )}

            <button className="bank-action-btn btn-deposit" onClick={() => navigate('/payment/deposit')}>
              <RiWallet3Line size={15} />
              <span>Nạp Tiền</span>
            </button>

            <button className="bank-action-btn btn-change-pass" onClick={() => setShowChangePasswordModal(true)}>
              <RiLockPasswordLine size={15} />
              <span>Đổi Mật Khẩu</span>
            </button>
          </div>
        </div>
      </div>

      {/* Main Bank Management Card */}
      <div className="card bank-main-card">
        {/* Card Header with Segmented Filter Tabs */}
        <div className="bank-card-header">
          <div className="d-flex align-items-center gap-2">
            <h5 className="bank-header-title mb-0">
              <RiBuilding4Line size={18} />
              <span>Danh Sách Bank Ảo</span>
            </h5>
            <span className="bank-total-pill">{allBanks.length}</span>
          </div>

          {/* Interactive Segmented Filter Pills */}
          <div className="bank-segmented-tabs">
            <button
              type="button"
              className={`seg-tab-btn ${accountTypeFilter === 'ALL' ? 'active' : ''}`}
              onClick={() => handleTabChange('ALL')}
            >
              <span>Tất cả</span>
              <span className="seg-tab-count">{allBanks.length}</span>
            </button>
            <button
              type="button"
              className={`seg-tab-btn vip-tab ${accountTypeFilter === 'VIP' ? 'active' : ''}`}
              onClick={() => handleTabChange('VIP')}
            >
              <RiVipCrown2Fill size={12} className="seg-vip-icon" />
              <span>Tài khoản VIP</span>
              <span className="seg-tab-count">{vipCount}</span>
            </button>
            <button
              type="button"
              className={`seg-tab-btn ${accountTypeFilter === 'NORMAL' ? 'active' : ''}`}
              onClick={() => handleTabChange('NORMAL')}
            >
              <span>Thường (Tính phí)</span>
              <span className="seg-tab-count">{normalCount}</span>
            </button>
          </div>
        </div>

        {/* Filter & Search Toolbar */}
        <div className="bank-toolbar">
          <div className="bank-perpage-wrap">
            <span>Hiển thị</span>
            <select 
              value={perPage} 
              onChange={handleChangePerPage} 
              className="bank-perpage-select"
            >
              <option value={5}>5 dòng</option>
              <option value={10}>10 dòng</option>
              <option value={25}>25 dòng</option>
              <option value={50}>50 dòng</option>
            </select>
            <span>trên <strong>{filteredBanks.length}</strong> tài khoản</span>
          </div>

          <form onSubmit={handleSubmit} className="bank-search-form">
            <div className="bank-search-input-box">
              <RiSearch2Line size={15} className="search-box-icon" />
              <input 
                type="text" 
                className="bank-search-input" 
                placeholder="Tìm STK, chủ tài khoản, SĐT..."
                name="search_text" 
                value={keyword.search_text} 
                onChange={handleChange} 
              />
              {keyword.search_text && (
                <button
                  type="button"
                  className="search-clear-btn"
                  onClick={handleClearSearch}
                  title="Xóa tìm kiếm"
                >
                  <RiCloseCircleLine size={15} />
                </button>
              )}
            </div>
            <button className="bank-search-btn" type="submit">
              <span>Tìm kiếm</span>
            </button>
          </form>
        </div>

        {/* Table Body */}
        <div className="card-body p-0">
          {loading ? (
            <div className="text-center py-5">
              <div className="spinner-border spinner-border-sm text-light" role="status"></div>
              <div className="mt-2" style={{ fontSize: '12.5px', color: 'var(--wus-text-subtle)' }}>Đang đồng bộ dữ liệu...</div>
            </div>
          ) : (
            <div className="bank-table-wrapper">
              <table className="bank-table">
                <thead>
                  <tr>
                    <th style={{width: '96px', textAlign: 'center'}}>Thao tác</th>
                    <th style={{width: '52px', textAlign: 'center'}}>STT</th>
                    <th>Ngân Hàng &amp; STK</th>
                    <th>SĐT / MK App</th>
                    <th>Chủ Tài Khoản</th>
                    <th>Thời Hạn</th>
                    <th>Số Dư App</th>
                    <th style={{textAlign: 'center', width: '125px'}}>Trạng Thái</th>
                  </tr>
                </thead>
                <tbody>
                  {banks.length === 0 ? (
                    <tr>
                      <td colSpan="8" className="text-center py-5" style={{ color: 'var(--wus-text-subtle)' }}>
                        Không tìm thấy tài khoản ngân hàng nào phù hợp
                      </td>
                    </tr>
                  ) : (
                    banks.map((bank, index) => (
                      <tr key={bank.id}>
                        {/* Action Dropdown */}
                        <td style={{textAlign: 'center'}}>
                          <Dropdown
                            show={openDropdownId === bank.id}
                            onToggle={(isOpen) => setOpenDropdownId(isOpen ? bank.id : null)}
                            autoClose={true}
                          >
                            <Dropdown.Toggle as={CustomToggle}>
                              Thao tác
                            </Dropdown.Toggle>
                            <Dropdown.Menu className="bank-action-dropdown">
                              <Dropdown.Item onClick={() => openHistory(bank)} className="bank-menu-item">
                                <span>Lịch sử giao dịch</span>
                              </Dropdown.Item>
                              <Dropdown.Item onClick={() => openDeposit(bank)} className="bank-menu-item">
                                <span>Nạp tiền vào app</span>
                              </Dropdown.Item>
                              <Dropdown.Item onClick={() => openUpdate(bank)} className="bank-menu-item">
                                <span>Sửa thông tin TK</span>
                              </Dropdown.Item>
                              {Number(bank.is_from_combo) !== 1 && userData?.combo_days > 0 && (
                                <Dropdown.Item onClick={() => handleSingleUpgrade(bank)} className="bank-menu-item">
                                  <span style={{color: '#fbbf24', fontWeight: '600'}}>Nâng cấp lên VIP</span>
                                </Dropdown.Item>
                              )}

                              <Dropdown.Item onClick={() => openPush(bank)} className="bank-menu-item">
                                <span>Push thông báo CK</span>
                              </Dropdown.Item>
                              <Dropdown.Item onClick={() => openEditBalance(bank)} className="bank-menu-item">
                                <span>Sửa số dư APP</span>
                              </Dropdown.Item>
                              <Dropdown.Item onClick={() => openRenew(bank)} className="bank-menu-item">
                                <span>Gia hạn Bank</span>
                              </Dropdown.Item>
                              <div className="bank-menu-divider"></div>
                              <Dropdown.Item onClick={() => handleDelete(bank.id)} className="bank-menu-item danger-item">
                                <span>Xóa tài khoản</span>
                              </Dropdown.Item>
                            </Dropdown.Menu>
                          </Dropdown>
                        </td>

                        {/* STT */}
                        <td style={{textAlign: 'center', color: 'var(--wus-text-subtle)', fontSize: '12px', fontFamily: 'var(--wus-mono)'}}>
                          {(page - 1) * perPage + index + 1}
                        </td>

                        {/* Ngân Hàng & STK */}
                        <td>
                          <div className="bank-type-badge-wrap d-flex align-items-center gap-1">
                            <span className="bank-type-badge">
                              {bank.type ? bank.type.replaceAll('-', ' ').toUpperCase() : 'BANK'}
                            </span>
                            {Number(bank.is_from_combo) === 1 && (
                              <span className="badge-combo-vip" title="Bank thuộc Gói Combo VIP">
                                <RiVipCrown2Fill size={10} /> VIP
                              </span>
                            )}
                          </div>
                          <div className="bank-number-row">
                            <span className="bank-number-text">{bank.bank_number}</span>
                            <button
                              type="button"
                              className="btn-copy-inline"
                              onClick={() => handleCopyText(bank.bank_number, `stk-${bank.id}`)}
                              title="Sao chép số tài khoản"
                            >
                              {copiedId === `stk-${bank.id}` ? (
                                <RiCheckLine size={12} color="#10b981" />
                              ) : (
                                <RiFileCopyLine size={12} />
                              )}
                            </button>
                          </div>
                        </td>

                        {/* SĐT / MK App */}
                        <td>
                          <div className="user-phone-text">{bank.phone || '-'}</div>
                          <div className="pass-toggle-wrap" onClick={() => togglePassword(bank.id)} title="Bấm để hiện/ẩn mật khẩu">
                            {visiblePasswords[bank.id] ? (
                              <span className="pass-revealed">{bank.password_decryption || '-'}</span>
                            ) : (
                              <span className="pass-hidden">••••••</span>
                            )}
                            <span className="pass-eye-icon">
                              {visiblePasswords[bank.id] ? <RiEyeOffLine size={13} /> : <RiEyeLine size={13} />}
                            </span>
                          </div>
                        </td>

                        {/* Chủ Tài Khoản */}
                        <td>
                          <div className="owner-name-text">
                            {bank.bank_username || '-'}
                          </div>
                        </td>

                        {/* Thời Hạn */}
                        <td>
                          <div className="date-created">Tạo: {formatDate(bank.account_active_user?.created_at)}</div>
                          <div className={`date-expired ${bank.account_active_user?.is_expired ? 'expired' : ''}`}>
                            Hạn: {formatDate(bank.account_active_user?.expired_date)}
                          </div>
                        </td>

                        {/* Số Dư */}
                        <td>
                          <div className="table-balance-amount">
                            {(bank.account_balance || 0).toLocaleString('vi-VN')} <span className="currency-unit">đ</span>
                          </div>
                        </td>

                        {/* Trạng Thái */}
                        <td style={{textAlign: 'center'}}>
                          {bank.account_active_user?.is_expired ? (
                            <span className="status-pill expired">
                              <span className="status-dot expired"></span>
                              <span>Hết hạn</span>
                            </span>
                          ) : (
                            <span className="status-pill ok">
                              <span className="status-dot ok"></span>
                              <span>Hoạt động</span>
                            </span>
                          )}
                        </td>
                      </tr>
                    ))
                  )}
                </tbody>
              </table>
            </div>
          )}

          {/* Pagination */}
          <div className="bank-pagination-wrap">
            <Paginate meta={meta} changePage={changePage} page={page} handleSetPage={handleSetPage} />
          </div>
        </div>
      </div>

      {/* Floating Telegram Support Widget */}
      <a 
        href="https://t.me/okbillcave" 
        target="_blank" 
        rel="noopener noreferrer" 
        className="bank-telegram-float" 
        title="Hỗ trợ Telegram"
      >
        <RiTelegramLine size={22} />
      </a>

      {/* Modals */}
      <ModalCreateBankAccount 
        show={showCreateBankModal} 
        onHide={() => setShowCreateBankModal(false)} 
        type="VIRTUAL" 
        reloadPage={reloadPage} 
        userData={userData} 
      />

      {selectedBank && (
        <>
          <ModalHistory show={showHistory} onHide={() => setShowHistory(false)} data={selectedBank} reloadPage={reloadPage} />
          <ModalDepositApp show={showDeposit} onHide={() => setShowDeposit(false)} 
            bankName={selectedBank.bank_name || selectedBank.name} BankStatus={selectedBank.status} 
            UserBankStatus={selectedBank.user_status} bin={selectedBank.bin} type={selectedBank.type}
            user_bank_account_id={selectedBank.id} reloadPage={reloadPage} PackAge={selectedBank.package} />
          <ModalUpdateAcount show={showUpdate} onHide={() => setShowUpdate(false)} data={selectedBank} reloadPage={reloadPage} />
          <ModalPushNoti show={showPush} onHide={() => setShowPush(false)} data={selectedBank} reloadPage={reloadPage} />
          <ModalEditBalance show={showEditBalance} onHide={() => setShowEditBalance(false)} 
            user_bank_account_id={selectedBank.id} account_balance={selectedBank.account_balance}
            is_from_combo={selectedBank.is_from_combo}
            reloadPage={reloadPage} id={selectedBank.bank_id || selectedBank.id} type={selectedBank.type} />
          <ModalRenewAccount show={showRenew} onHide={() => setShowRenew(false)} 
            data={selectedBank}
            bankName={selectedBank.bank_name || selectedBank.name} isPriority={selectedBank.is_priority}
            bin={selectedBank.bin} type={selectedBank.type} user_bank_account_id={selectedBank.id}
            id={selectedBank.id}
            reloadPage={reloadPage} PackAge={selectedBank.package}
            userData={userData} />
        </>
      )}

      <ModalChangePassword show={showChangePasswordModal} onHide={() => setShowChangePasswordModal(false)} reloadPage={reloadPage} />
      <ModalComboPromo show={showComboPromo} onHide={() => setShowComboPromo(false)} onOrderSuccess={reloadPage} />

      {/* Modal Kích Hoạt Mã Code / Giftcode */}
      <Modal 
        show={showCodeModal} 
        onHide={() => setShowCodeModal(false)} 
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>
            <RiCoupon3Line size={19} style={{ color: 'var(--wus-text)' }} />
            <span>Kích Hoạt Mã Code / Giftcode</span>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="text-center mb-4">
            <h5 style={{ color: 'var(--wus-text)', fontWeight: '600', fontSize: '16px', marginBottom: '4px' }}>
              Đổi Mã Thưởng &amp; Lượt VIP
            </h5>
            <p style={{ color: 'var(--wus-text-muted)', fontSize: '13px', margin: 0 }}>
              Hỗ trợ mã nạp tiền số dư hoặc mã cộng lượt VIP theo ngày
            </p>
          </div>

          <div className="mb-4">
            <label className="form-label">Nhập mã code khuyến mãi:</label>
            <div className="d-flex gap-2">
              <input
                type="text"
                className="form-control"
                placeholder="Ví dụ: VIP8A9B2C, CODE250K..."
                value={quickCode}
                onChange={(e) => setQuickCode(e.target.value.toUpperCase().trim())}
                style={{
                  fontWeight: "700",
                  fontSize: "14px",
                  fontFamily: "var(--wus-mono)",
                  letterSpacing: "0.06em",
                  textTransform: "uppercase"
                }}
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    handleQuickDepositCode();
                  }
                }}
              />
              <button
                className="btn btn-primary"
                type="button"
                onClick={handleQuickDepositCode}
                disabled={isSubmittingQuickCode}
                style={{
                  padding: "0 20px",
                  whiteSpace: "nowrap",
                  display: "inline-flex",
                  alignItems: "center",
                  gap: "6px"
                }}
              >
                <RiShieldFlashLine size={15} />
                <span>{isSubmittingQuickCode ? "Đang xử lý..." : "Kích Hoạt"}</span>
              </button>
            </div>
          </div>

          {/* Information Callout Box */}
          <div className="wus-info-box mb-3">
            <div className="d-flex align-items-start gap-2 mb-2">
              <RiVipCrown2Fill size={15} style={{ color: 'var(--wus-warning-text)' }} className="mt-1 flex-shrink-0" />
              <span style={{ color: "var(--wus-text-secondary)", fontSize: "12.5px" }}>
                <strong style={{ color: "var(--wus-text)" }}>Mã VIP theo ngày:</strong> Tự động cộng ngày VIP &amp; số lượt VIP tương ứng (1 lượt = 30 ngày) để tạo và gia hạn Bank VIP.
              </span>
            </div>
            <div className="d-flex align-items-start gap-2">
              <RiWallet3Line size={15} style={{ color: 'var(--wus-success-text)' }} className="mt-1 flex-shrink-0" />
              <span style={{ color: "var(--wus-text-secondary)", fontSize: "12.5px" }}>
                <strong style={{ color: "var(--wus-text)" }}>Mã Tiền mặt:</strong> Tự động cộng số tiền tương ứng trực tiếp vào số dư khả dụng của bạn.
              </span>
            </div>
          </div>

          {/* User Current VIP & Balance Status */}
          <div className="wus-summary-box">
            <div className="d-flex justify-content-between align-items-center mb-2">
              <span style={{ color: "var(--wus-text-muted)", fontSize: "12.5px" }}>Số dư khả dụng:</span>
              <span style={{ color: "var(--wus-text)", fontWeight: "700", fontSize: "13.5px", fontFamily: "var(--wus-mono)" }}>
                {getUserBalance().toLocaleString('vi-VN')} đ
              </span>
            </div>
            <div className="d-flex justify-content-between align-items-center mb-2">
              <span style={{ color: "var(--wus-text-muted)", fontSize: "12.5px" }}>Quỹ ngày VIP hiện tại:</span>
              <span style={{ color: "var(--wus-warning-text)", fontWeight: "600", fontSize: "13px" }}>
                {userData?.combo_days || 0} ngày (~{Math.floor((userData?.combo_days || 0) / 30)} lượt)
              </span>
            </div>
            <div className="d-flex justify-content-between align-items-center">
              <span style={{ color: "var(--wus-text-muted)", fontSize: "12.5px" }}>Trạng thái gói VIP:</span>
              <span style={{ color: "var(--wus-success-text)", fontSize: "12.5px", fontWeight: "600" }}>
                {userData?.combo_days > 0 ? "Bảo lưu vĩnh viễn" : "Chưa kích hoạt"}
              </span>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <button className="btn btn-secondary" onClick={() => setShowCodeModal(false)}>
            Đóng
          </button>
        </Modal.Footer>
      </Modal>
    </MasterLayout>
  );
}

export default BankPage;
